import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-ava-product',
  imports: [CommonModule, TranslateModule],
  templateUrl: './ava-product.component.html',
  styleUrl: './ava-product.component.scss',
})
export class AvaProductComponent {
  featureKeys = ['F1', 'F2', 'F3', 'F4', 'F5', 'F6'];
}
